class Round {
  /**
   *
   * @param numbers Сколько знаков после запятой необходимо вывести. Если значение отрицательное, то кол-во знаков перед запятой.
   * @default numbers = 0
   * @example
   * afterSign(123.456789, 2) // 123.46
   * afterSign(123.456789, -2) // 100
   */

  public afterSign(
    value: number,
    numbers: number = 0,
    rounding: "floor" | "round" | "ceil" = "round",
  ) {
    const multiplier = 10 ** numbers;
    return Math[rounding](value * multiplier) / multiplier;
  }

  //

  /**
   * @param factor Значение, по которому будет округляться число.
   * @example
   * byFactor(123.456789, 5) // 125
   * byFactor(123.456789, 50) // 100
   * byFactor(123.456789, 50, "ceil") // 150
   * byFactor(123.45678, -10) // 120, отрицательные числа ничего не меняют в логике, как будто берется модуль числа
   */

  public byFactor(value: number, factor: number, rounding: "floor" | "round" | "ceil" = "round") {
    return Math[rounding](value / factor) * factor;
  }
}

export default new Round();
